
  import Vue from 'vue';
  import vSelect from 'vue-select';
  import { Component, Watch } from 'vue-property-decorator';

  Vue.component('v-select', vSelect);
  const extendedVSelect = Vue.extend({
    extends: vSelect,
    methods: {
      maybeAdjustScroll() { return false; },
    },
  });

  @Component
  export default class VSelectNoPointerScroll extends extendedVSelect {
    public selected: any = null;
    public isValid = false;

    public created() {
      this.selected = { name: this.$t('install_page.page_drop_down_hint'), accessToken: '' };
    }

    @Watch('selected')
    public updateValidSelect() {
      if (this.selected !== null && this.selected.accessToken !== '') {
        this.isValid = true;
        this.$store.commit('setSelectedPage', this.selected);
        this.$emit('IsValid');
      } else {
        if (this.selected === null) {
          this.selected = { name: this.$t('install_page.page_drop_down_hint'), accessToken: '' };
        }

        this.isValid = false;
        this.$store.commit('setSelectedPage', null);
        this.$emit('IsNotValid');
      }
    }
  }
